<div class="input-group" *ngIf="isRequesting">
  <label class="font-size-12px text-muted">Loading...</label>
</div>
<div class="input-group" *ngIf="!isRequesting">
  <select class="form-control" name="value" [(ngModel)]="value" (change)="onChange($event.target.value)">
    <option *ngFor="let R of ddlRefferedType" 
            [value]="(R.ShortValue != null && R.ShortValue !== '') ? R.ShortValue : ((R.shortValue != null && R.shortValue !== '') ? R.shortValue : (R.Code != null ? R.Code : (R.code != null ? R.code : R.DisplayName)))"
            [selected]="R.ShortValue == SelectedValue || R.LongValue == SelectedValue || R.DisplayName == SelectedValue || R.Code == SelectedValue">
      {{R.LongValue || R.longValue || R.DisplayName || R.displayName || R.SearchName || R.ShortValue}}
    </option>
  </select>
  <div *canUserAccess="['Add/EditCodeTypeValue']">
    <a class="padding-left-5px" (click)="EditCodeType()"><i class="fa fa-info-circle nav-link-hand font-size-12px margin-top-5px"></i></a>
  </div>
</div>
